<template>
  <div class="keyboard-selection" v-click-outside="onClickOutside">
    <label class="keyboard-selection__label">Keyboard layout:</label>
    <span
      class="keyboard-selection__selected"
      @click="showKeyboardModal = !showKeyboardModal"
      ><span class="keyboard-selection__flag">{{ keyboardSelected.flag }}</span>
      <span class="keyboard-selection__selected-text">
        {{ keyboardSelected.country }}
      </span>
    </span>
    <transition name="slide">
      <div class="keyboard-selection__modal" v-if="showKeyboardModal">
        <div class="keyboard-selection__modal-wrapper">
          <XIcon
            size="13"
            @click="showKeyboardModal = false"
            class="keyboard-selection__modal__close"
          />
          <h4 class="keyboard-selection__modal-title">
            Keyboard layout
          </h4>
          <div class="keyboard-selection__modal-list">
            <div
              v-for="keyboard in possibleKeyboards"
              :key="keyboard.code"
              class="keyboard-selection__modal-list__item"
              :class="[
                'keyboard-selection__modal-list__item',
                isSelected(keyboard) &&
                  'keyboard-selection__modal-list__item--selected',
              ]"
            >
              <label class="keyboard-checkbox">
                <div class="keyboard-checkbox__text">
                  <span class="keyboard-selection__flag"
                    >{{ keyboard.flag }} </span
                  >{{ keyboard.country }}
                </div>
                <span class="keyboard-checkbox__input">
                  <input
                    :class="[
                      isSelected(keyboard) && 'keyboard-checkbox--checked',
                    ]"
                    type="radio"
                    :name="`${keyboard.code}-checkbox`"
                    :value="keyboard.code"
                    v-model="currentSelection"
                  />
                  <span
                    :class="
                      `keyboard-checkbox__control keyboard-checkbox__control--radio`
                    "
                  >
                    <span class="keyboard-checkbox__radio-dot" />
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { XIcon } from 'vue-feather-icons'

export default {
  name: 'LabKeyboardSelection',
  components: {
    XIcon,
  },
  data: () => {
    return {
      showKeyboardModal: false,
      currentSelection: null,
      keyboardSelected: {
        country: 'English (US)',
        code: 'en-us-qwerty',
        flag: '🇺🇸',
      },
      possibleKeyboards: [
        {
          country: 'Brazilian (Portuguese)',
          code: 'pt-br-qwerty',
          flag: '🇧🇷',
        },
        {
          country: 'English (UK)',
          code: 'en-gb-qwerty',
          flag: '🇬🇧',
        },
        {
          country: 'English (US)',
          code: 'en-us-qwerty',
          flag: '🇺🇸',
        },
        {
          country: 'Danish',
          code: 'da-dk-qwerty',
          flag: '🇩🇰',
        },
        {
          country: 'French',
          code: 'fr-fr-azerty',
          flag: '🇫🇷',
        },
        {
          country: 'French (Belgian)',
          code: 'fr-be-azerty',
          flag: '🇫🇷',
        },
        {
          country: 'French (Swiss)',
          code: 'fr-ch-qwertz',
          flag: '🇫🇷',
        },
        {
          country: 'German',
          code: 'de-de-qwertz',
          flag: '🇩🇪',
        },
        {
          country: 'German (Swiss)',
          code: 'de-ch-qwertz',
          flag: '🇩🇪',
        },
        {
          country: 'Hungarian',
          code: 'hu-hu-qwertz',
          flag: '🇭🇺',
        },
        {
          country: 'Italian',
          code: 'it-it-qwerty',
          flag: '🇮🇹',
        },
        {
          country: 'Japanese',
          code: 'ja-jp-qwerty',
          flag: '🇯🇵',
        },
        {
          country: 'Norwegian',
          code: 'no-no-qwerty',
          flag: '🇳🇴',
        },
        {
          country: 'Spanish',
          code: 'es-es-qwerty',
          flag: '🇪🇸',
        },
        {
          country: 'Spanish (Latin American)',
          code: 'es-latam-qwerty',
          flag: '🇪🇸',
        },
        {
          country: 'Swedish',
          code: 'sv-se-qwerty',
          flag: '🇸🇪',
        },
        {
          country: 'Turkish-Q',
          code: 'tr-tr-qwerty',
          flag: '🇹🇷',
        },
      ],
    }
  },
  methods: {
    isSelected(keyboard) {
      return this.keyboardSelected.code === keyboard.code
    },
    onClickOutside(event) {
      this.showKeyboardModal = false
    },
  },
  watch: {
    currentSelection(value) {
      this.keyboardSelected = this.possibleKeyboards.find(k => k.code === value)
      localStorage.setItem(`pta-lab-keyboard`, value)
      this.$emit('keyboad-changed', value)
    },
  },
  mounted() {
    this.currentSelection =
      localStorage.getItem(`pta-lab-keyboard`) || 'en-us-qwerty'
  },
}
</script>
<style lang="scss" scoped>
.keyboard-selection {
  margin-bottom: 35px;
  position: relative;
  font-size: rem(12px);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  &__selected {
    cursor: pointer;
    color: var(--white);
    margin-left: 10px;
    display: flex;
    align-items: center;
    &-text {
      border-bottom: 1px solid var(--white);
    }
  }
  &__modal {
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 30px;
    background: var(--glass-mid-gray);
    background-color: var(--darker-gray);
    border-radius: 10px;
    text-align: left;
    z-index: 999;
    &-wrapper {
      padding: 20px 5px 20px 20px;
    }
    &__close {
      position: absolute;
      right: 0;
      top: 0;
      margin: 22px;
      cursor: pointer;
      opacity: 0.7;
      &:hover {
        opacity: 1;
      }
      &:active {
        opacity: 0.4;
      }
    }
    &-title {
      margin: 16px 0 10px;
      font-size: rem(18px);
      line-height: 24px;
      font-weight: normal;
    }
  }
  &__flag {
    font-size: rem(21px);
    line-height: 0;
  }
  &__text {
    display: flex;
    align-items: center;
  }
  &__modal-list {
    overflow: auto;
    height: 328px;
    &__item {
      padding-right: 20px;
      color: var(--light-blue-gray);
      &--selected {
        color: var(--white);
      }
    }
  }
}
</style>
